import { Result, failure, success } from '../shared'
import { ProductProvider } from './product.provider'
import {
  ProductServiceErrorCode,
  ProductDetailsServerData,
  ProductFailure,
  ProductList,
  ProductPage,
} from './product.types'

export class ProductService {
  constructor(private provider: ProductProvider) {}

  public async getDetails(id: number, hash: string): Promise<Result<ProductDetailsServerData, ProductFailure>> {
    try {
      const { data } = await this.provider.get<ProductDetailsServerData>(ProductPage.Details, {
        ProductID: id,
        HashSum_ProductID_: hash,
      })
      return success(data)
    } catch (error) {
      return failure(ProductServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async getList(): Promise<Result<ProductList, ProductFailure>> {
    try {
      const { data } = await this.provider.get<ProductList>(ProductPage.List)
      return success(data)
    } catch (error) {
      return failure(ProductServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async getBIC(): Promise<Result<any, ProductFailure>> {
    try {
      const { data } = await this.provider.get<any>(ProductPage.BIC)
      return success(data)
    } catch (error) {
      return failure(ProductServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async getPawnshop(): Promise<Result<any, ProductFailure>> {
    try {
      const { data } = await this.provider.get<any>(ProductPage.Pawnshop)
      return success(data)
    } catch (error) {
      return failure(ProductServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
}
